// extracted by mini-css-extract-plugin
export default {"contact":"ButtonWrapper_contact__DroTx","website_btn":"ButtonWrapper_website_btn__-nLep","contact_btn":"ButtonWrapper_contact_btn__2eFR0"};